import { render, staticRenderFns } from "./staffList.vue?vue&type=template&id=825b87de&scoped=true"
import script from "./staffList.js?vue&type=script&lang=js&external"
export * from "./staffList.js?vue&type=script&lang=js&external"
import style0 from "./staffList.vue?vue&type=style&index=0&id=825b87de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825b87de",
  null
  
)

export default component.exports